import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  updateSubscriptionRequest,
  updateSubscriptionRequestSuccess,
  updateSubscriptionRequestError,
} from "../../../slices/teams/members/UpdateSubscriptionSlice";

export const UpdateSubscription = (id, payload) => async (dispatch) => {
  try {
    dispatch(updateSubscriptionRequest());

    const url = `${endpoints.updateSubscription}/${id}`;

    const response = await axiosInstance.put(url, payload, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(updateSubscriptionRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to update subscription";

    const _error = {
      data: errorMessage,
      status: error?.response?.status,
    };

    dispatch(updateSubscriptionRequestError(_error));
    throw _error;
  }
};
